import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, { FormBody, FormActions, TextInput, SelectInput } from '../../Form';
import { timezones } from '../../../libs/date';

@inject('stationStore', 'dataOriginStore')
@observer
class StationDataOriginAdd extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug = '/data-origin';
  title = 'Add Station Data Origin';
  @observable dataOrigin = {
    data_origin_id: '',
    timezone: '',
  };
  dispose;

  constructor(props) {
    super(props);

    const { params: { id }, stationStore, dataOriginStore } = props;
    dataOriginStore.fetchItems();
  }

  @action onChangeDataOrigin = (event) => {
    this.dataOrigin.data_origin_id = +event.target.value;
  }
  @action onChangeTimezone = (event) => {
    this.dataOrigin.timezone = event.target.value;
  }

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify } = this.context;
    const { params: { id }, stationStore } = this.props;
    const slug = `/station/${id}/data-origin`;
    stationStore
      .addDataOrigin(id, this.dataOrigin)
      .then(() => {
        this.context.router.push(slug);
        notify.success({ message: 'Added Data Origin' });
      })
      .catch(notify.error);
  }

  render() {
    const { params: { id }, dataOriginStore } = this.props;
    const slug = `/station/${id}/data-origin`;

    const dataOrigins = dataOriginStore.items.toJS() || [];

    if (dataOriginStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={slug}>
        <Form>
          <FormBody>
            <SelectInput
              label={'Data Origin'}
              fields={{ label: 'code', value: 'id' }}
              options={dataOrigins}
              value={this.dataOrigin.data_origin_id}
              onChange={this.onChangeDataOrigin}
              sortOptions={(a,b) => a.code < b.code ? -1 : 1}
            />
            <SelectInput
              label={'Timezone'}
              fields={{ label: 'offset', value: 'offset' }}
              options={timezones}
              value={this.dataOrigin.timezone}
              onChange={this.onChangeTimezone}
            />
            <TextInput label={'Installed'} value={(new Date()).toISOString()} readOnly />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default StationDataOriginAdd;



// WEBPACK FOOTER //
// ./src/components/Station/DataOrigin/StationDataOriginAdd.js